export enum Weapon {
  Rock = 0,
  Paper = 1,
  Scissors = 2,
}
